<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2 ziro-datatable-content">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div [innerHTML]="'tkey;admin.order_numbers.port_in_orders.about' | escapeHtml"></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>
    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading) {
      <ziro-datatable
        [dataAutomation]="tableDataAutomation"
        [columns]="datatableCols"
        [rowDataSource]="datatableRows"
        [uniqueRowIdentifier]="'id'"
        [mainFilterPlaceholder]="'tkey;admin.order_numbers.port_in_orders.datatable.filter.placeholder' | translate"
        [maxLength]="150"
        [stickyColumnCount]="1"
        [setColumnWidths]="false"
        [noResultsAlert]="
          !datatableRows.length ? ('tkey;admin.order_numbers.port_in_orders.no_orders_found.text' | translate) : ''
        "
        [noResultsAlertClass]="!datatableRows.length ? 'alert-light' : ''"
        [isLoadingSecondaryData]="isLoadingSecondaryData"
        [persistFilters]="true"
        [matchesSecondaryDataFn]="matchesSecondaryDataFn"
        [class]="'ziro-card'"
      >
        <ziro-datatable-multi-select-filter
          [label]="'tkey;admin.order_numbers.port_in_orders.datatable.processing_status.label'"
          [items]="processingStatusOptions"
          [matchFn]="isProcessingStatusMatchFn"
          [labelCssClass]="'text-capitalize'"
          [dataAutomation]="'processing-status-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-multi-select-filter>
        <ziro-datatable-date-filter
          [label]="'tkey;admin.order_numbers.port_in_orders.datatable.foc_date.label'"
          [matchFn]="isDateMatchFn"
          [dataAutomation]="'foc-date-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-date-filter>
      </ziro-datatable>
    }
  </div>
</div>
<ziro-bottom-nav></ziro-bottom-nav>
